/**
 * @override
 * This functionality was turn off
 * Jumio popup should not appear on app init triggered by presents of player tag risk/doc/upload_requirement with value "mandatory"
 * @returns {null}
 */
export const useJumioVerifyPopup = () => {
    return null;
};
